export default "__VITE_ASSET__C9VTUVkn__"